/**
 *
 * @param popupWidth
 * @param popupHeight
 * @returns the x/left and y/top position, which you can use as a
 *  popup window's left and top for centering the popup window
 *
 */
export const getPopupWindowCenter = (popupWidth: number, popupHeight: number) => {
  const windowCenterX = window.outerWidth / 2 + (window.screenX || screenLeft)
  const windowCenterY = window.outerHeight / 2 + (window.screenY || window.screenTop)

  return {
    x: windowCenterX - popupWidth / 2,
    y: windowCenterY - popupHeight / 2,
  }
}

type Options = {
  name?: string
  width?: number
  height?: number
}

type OpenPopupWindow = (url: string, options?: Options) => Window | null

export const openPopupWindow: OpenPopupWindow = (
  url,
  { name = '', width = 550, height = 480 } = {},
) => {
  const center = getPopupWindowCenter(width, height)
  return window.open(url, name, `width=${width},height=${height},top=${center.y},left=${center.x}`)
}
